
import {of as observableOf,  Observable } from 'rxjs';
import {catchError} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { IApiKey } from './apikeys-model';

@Injectable()
export class ApiKeysService {
    constructor(private http: HttpClient) { }

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}${ApiKeysService.ENDPOINT}`; }
    private static readonly ENDPOINT = '/apikeys';

    public getApiKey(): Observable<SuccessResponse<IApiKey> | ErrorResponse> {
        return this.http
            .get<SuccessResponse<IApiKey>>(ApiKeysService.URL).pipe(
            catchError(error => observableOf(new ErrorResponse(error.error))));
    }

}
